import { Carousel } from 'component/Carousel/Carousel'
import { Indicators } from 'component/Carousel/co/Indicators/Indicators'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { Card2 } from 'page/Fullscreen/Recommendations/Card2'
import { OfferItem } from 'type/rec'
import css from './RecommendationsView.module.scss'

type Props = {
  carousel: CarouselStore<OfferItem>
}

export const RecommendationsView = observer(({ carousel }: Props) => {
  const { many } = carousel

  const render = useLatestCallback((item: OfferItem) => {
    return <Card2 carousel={carousel} item={item} />
  })

  return <Vertical className={css.view} gap={16} pad={[16, 8]}>
    <Space spring>
      <Carousel store={carousel} render={render} />
    </Space>
    {many && <Space center>
      <Indicators carousel={carousel} white />
    </Space>}
  </Vertical>
})
